import React from 'react';
import './Loader.scss';
import { ReactComponent as Spinner } from '../../assets/spinner.svg';

const Loader = ({ size= 100, light }) => {
  return (
    <div className='Loader'>
      <Spinner className={light ? 'light' : 'dark'} width={size} height={size} />
    </div>
  )
};

export default Loader;
